import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, filter, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { FileUploadResponse } from 'src/app/core/models/file-upload-results.model';
import { environment } from 'src/app/environments/environment';
import { WarehouseScanRequest } from '../../../models/inbound/warehouse';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class WarehouseScanService {
  private readonly _http = inject(HttpClient);
  private readonly _errorHandler = inject(ErrorhandleService);

  readonly baseUrl = environment.apiUrl;

  /**
   *add Warehouse Scan
   * @return {*}  {Observable<WarehouseScanResponse>}
   * @memberof WarehouseScanService
   */
  addWarehouseScan(
    warehouseScanRequest: WarehouseScanRequest,
  ): Observable<FileUploadResponse> {
    return this._http
      .post<FileUploadResponse>(
        this.baseUrl.concat('/inbound-scans/add-warehouse-scan'),
        warehouseScanRequest,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<FileUploadResponse>(
            error,
            error.error.code,
            'WarehouseScan Service: add warehouse scan',
            BANNER_TYPE.API_400_ERROR,
            {} as FileUploadResponse,
          ),
        ),
        filter((val) => !!val),
      );
  }
}
